<template>
  <div class="home-page" id="index-view">
    <a-layout class="h-cont" v-if="true">
      <a-layout-header  class="flex-between" theme="dark">
        <div class="flex-left">
          <div class="hch-icon">
            <img src="../assets/images/longlogo.png" alt="" />
          </div>
          <div class="hch-title">龙昌桂e康运营分析平台</div>
        </div>
        <div class="flex-right">
          <div class="flex-left hchr-ul">
            <!-- <div v-for="(item, inx) in navList" :key="inx">{{ item.name }}</div> -->
            <span v-for="(item, index) in topMenu" :key="index" @click="routerPush(item.path)">{{ item.name }}</span>
            <!-- <span @click="userPortrait">用户画像</span>
            <span @click="unpurchasedCustomers">未购访客</span>
            <span @click="DealData">交易数据</span>
            <span @click="searchLeaderboard">热搜排行榜</span> -->
          </div>
          <div class="flex-left">
            <div class="hch-text m-r-10" style="cursor: pointer" @click="newIndexView">
              消息
            </div>
            <a-badge :count="count">
              <img class="hchr-icon" src="../assets/images/icon-msg.png" alt="" @click="newIndexView" />
            </a-badge>
          </div>
          <div class="flex-left m-l-40">
            <div class="hch-icon">
              <img :src="avatar ? 'http://point.csycj.com/' + avatar : '@/assets/images/avatar.png'"
                :onerror="defaultGoodsImg" style="border-radius: 50%;" />
            </div>
            <div class="hch-text m-l-10">
              <a-dropdown placement="bottom">
                <div class="flex-left">
                  <span class="m-r-6">{{ username }}</span>
                  <!-- <CaretDownOutlined /> -->
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item @click="personal"> 个人资料 </a-menu-item>
                    <!-- <a-menu-item @click="changeDaprtBtn">
                      切换部门
                    </a-menu-item> -->
                    <a-menu-item @click="changePaddword">
                      修改密码
                    </a-menu-item>
                    <a-menu-item @click="quit"> 退出登录 </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </div>
        </div>
      </a-layout-header>
      <a-layout>
        <a-layout-sider  width="1.0417rem" v-model:collapsed="collapsed" collapsedWidth="45px">
          <a-menu  mode="inline" :openKeys="openKeys" v-model:selectedKeys="selectedKeys" @openChange="onOpenChange"
            @click="changeMenu">
            <template v-for="(item, index) in menu">
              <a-menu-item v-if="!item.children" :key="item.path" :path="item.path">
                <template #icon>
                  <div class="lsm-icon" :class="['lsm-icon' + index]"></div>
                </template>
                {{ item.name }}
              </a-menu-item>
              <a-sub-menu v-else :key="item.id + ''">
                <template #icon>
                  <div class="lsm-icon" :class="['lsm-icon' + index]"></div>
                </template>
                <template #title>{{ item.name }}</template>
                <a-menu-item v-for="li in item.children" :key="li.path" :path="li.path">
                  {{ li.name }}
                </a-menu-item>
              </a-sub-menu>
            </template>
          </a-menu>
        </a-layout-sider>
        <!-- 页面主要内容展示区域 -->
        <a-layout-content>
          <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
  <a-modal v-model:visible="quitopen" width="300px" title="" :closable="false" :footer="false" @ok="handleOk">
    <div class="m-t-20">
      <div class="" style="text-align:center;width:100%;font-size:18px;font-weight:600">
        <ExclamationCircleOutlined style="color: #f5222d;margin-right: 10px;" />提示
      </div>
      <div class="m-t-20" style="text-align:center;width:100%">确定要退出登录吗？</div>
      <div class="flex-cen" style="margin-top: 20px;">
        <a-button @click="quitopen = false">取消</a-button>
        <a-button type="primary" class="m-l-20" danger ghost @click="handleOk">确定</a-button>
      </div>
    </div>
  </a-modal>
  <change-daprt v-if="showChangeDaprt" @close="closeChangeDaprt"></change-daprt>
  <IndexViewNews v-if="showIndexViewNews" @close="closeIndexViewNews" @upDataCount="onUnDataCount"></IndexViewNews>
</template>

<script setup>
// @ is an alias to /src
import { reactive, toRefs, ref, onMounted, watchEffect } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { onBeforeRouteUpdate, useRouter } from "vue-router";
// import { CaretDownOutlined } from "@ant-design/icons-vue";
// import { menu } from "@/configData/homeView"; // 侧边菜单
// import defaultAvatar from "@/assets/images/avatar.png";
import { message } from "ant-design-vue";
// import { useStore } from "vuex";
// quitApi  退出登录API
import { infoApi, } from "@/api/homePageApi/homePageApi";
// const store = useStore()
import changeDaprt from "./changeDepaet.vue";
import { getPermissionApi } from "@/api/homePageApi/homePageApi";
// import { transData, addRoute, HomeRoute } from "@/router";/*  */
import IndexViewNews from "./IndexViewNews.vue";
import { topNavApi } from "@/api/homePageApi/homePageApi";
import { announcementUserApi } from "@/api/messageCenterApi/messageCenterApi";
import { useStore } from "vuex";

const defaultGoodsImg = ref('src="' + require("@/assets/images/avatar.png") + '"')


const store = useStore()
const menu = ref([]);
//左侧路由请求
const routeName = () => {
  getPermissionApi().then((res) => {
    menu.value = res.data;
    menu.value.forEach((item) => {
      if (item.children) state.rootSubmenuKeys.push(item.id);
    });
  });
};
//顶部导航请求
const topMenu = ref([]);
const topNav = () => {
  topNavApi().then((res) => {
    topMenu.value = res.data;
  });
};
//顶部跳转
const routerPush = (path) => {
  router.push(path);
};

//顶部导航徽标数
const count = ref(0);
const onUnDataCount = () => {
  topCoount()
}
const topCoount = () => {
  setTimeout(() => {
    announcementUserApi().then((res) => {
      count.value = res.data.read_count;

    });
  }, 1000)
};

const router = useRouter();
router.beforeEach((to, from, next) => {
  next()
})
onBeforeRouteUpdate(() => {
  routeName()
})
// const navList = [
//   { name: "商品画像" },
//   { name: "用户画像" },
//   { name: "活动对比" },
//   { name: "用户留存" },
//   { name: "未购访客" },
// ];
// const menuChildIds = []; // 子菜单id合集

const selectedKeys = ref(["/"]);
onMounted(() => {
  if (localStorage.getItem("path")) {
    selectedKeys.value = [localStorage.getItem("path")];
  }
});
const state = reactive({
  rootSubmenuKeys: [],
  openKeys: [],
  collapsed: false,
});

// 根据屏幕宽度设置侧边栏展示状态
const setMenuSty = () => {
  const width = document.documentElement.clientWidth;
  if (!state.collapsed && width < 1400) {
    state.collapsed = true;
  } else if (state.collapsed && width >= 1400) {
    state.collapsed = false;
  }
};

// 监听页面宽度变化，设置左侧菜单样式
setMenuSty();
onresize = () => {
  setMenuSty();
};

// 处理左侧菜单简洁聚焦（只展开选中项）
const onOpenChange = (openKeys) => {
  const latestOpenKey = openKeys.find((key) => state.openKeys.indexOf(key) === -1
  );
  if (state.rootSubmenuKeys.indexOf(Number(latestOpenKey)) === -1) {
    state.openKeys = openKeys;
  } else {
    state.openKeys = latestOpenKey ? [latestOpenKey] : [];
  }
};

const changeMenu = ({ item }) => {
  const { path } = item;
  if (path) router.push(path);
  else console.log("路由为空！");
  localStorage.setItem("path", path);
};
// 使用 watch 监听路由的变化
watchEffect(() => {
  // 获取当前路由路径
  const currentPath = router.currentRoute.value.path;

  // 在这里更新导航栏的选中状态
  // 可以遍历 menu.value 来找到当前路由对应的菜单项，然后设置选中状态
  for (const item of menu.value) {
    if (item.path === currentPath) {
      // 找到匹配的菜单项，设置选中状态
      // 这可能需要修改你的 menu 数据结构以支持更好的匹配
      selectedKeys.value = [item.path];
      return;
    }
    if (item.children) {
      for (const childItem of item.children) {
        if (childItem.path === currentPath) {
          selectedKeys.value = [childItem.path];
          return;
        }
      }
    }
  }
});
const { openKeys, collapsed } = toRefs(state);
const username = ref("");
const avatar = ref("");
const id = ref();
infoApi()
  .then((res) => {
    username.value = res?.data?.username;
    id.value = res?.data?.id;
    avatar.value = res?.data?.avatar;
    store.commit('setDealerUserInfo', res?.data?.username)
  })
//个人资料
const personal = () => {
  router.push("/personalInfo");
};

const showChangeDaprt = ref(false);
//切换部门
// const changeDaprtBtn = () => {
//   showChangeDaprt.value = true;
// };
const closeChangeDaprt = () => {
  showChangeDaprt.value = false;
};

//修改密码
const changePaddword = () => {
  router.push("/changePassword");
};
//退出登录
const quitopen = ref(false)
function handleOk() {
  quitopen.value = false
  store.commit('setToken', '')
  router.push("/login");
  message.success('成功退出登录')
}
const quit = () => {
  quitopen.value = true
  // Modal.warning({
  //   title: "确定要退出吗？",
  //   icon: createVNode(ExclamationCircleOutlined),
  //   okText: "确定",
  //   okType: "danger",
  //   cancelText: "取消",
  //   onOk(e) {
  //     console.log(e);

  //     return

  //     // setTimeout(() => {


  //     // }, 50);

  //   },
  //   onCancel() {

  //   },
  // });
};
//消息部分
const showIndexViewNews = ref(false);
const newIndexView = () => {
  showIndexViewNews.value = true;
};
const closeIndexViewNews = () => {
  showIndexViewNews.value = false;
};

onMounted(() => {
  routeName();
  topNav();
  topCoount();
});
</script>

<style lang="scss">
.home-page {
  height: 100%;
}

.h-cont {
  min-height: 100% !important;
}

// header
#index-view .ant-layout-header {
  height: 0.3125rem !important;
  display: flex;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  background-color: $mainColor;
  padding: 0 0.1563rem;

  .hch-icon {
    width: 0.1875rem;
    height: 0.1875rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .hch-title {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    margin-left: 9px;
  }

  .hchr-ul {
    margin-right: 0.3542rem;

    &>span {
      margin-right: 0.3125rem;
      cursor: pointer;
    }
  }

  .hchr-icon {
    width: 18px;
    height: 18px;
  }

  .el-dropdown {
    color: #ffffff;
  }
}

// 侧边栏
#index-view .ant-layout-sider {
  color: #333;
  background: #fff;

  .lsm-icon {
    width: 20px;
    height: 20px;
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      display: block;
      width: 525px;
      height: 88px;
      background: rgba(255, 255, 0, 0) url(@/assets/images/icon-menu2.png) no-repeat top left / 100% 100%;
      position: absolute;
      top: -50px;
    }
  }

  .lsm-icon0::after {
    left: -30px;
  }

  .lsm-icon1::after {
    left: -439px;
  }

  .lsm-icon2::after {
    left: -484px;
  }

  .lsm-icon3::after {
    left: -255px;
  }

  // -165
  .lsm-icon4::after {
    left: -75px;
  }

  .lsm-icon5::after {
    left: -120px;
  }

  .lsm-icon6::after {
    left: -165px;
  }

  .lsm-icon7::after {
    left: -210px;
  }

  .lsm-icon8::after {
    left: -301px;
  }

  // 443
  .lsm-icon9::after {
    left: -348px;
  }

  // .lsm-icon10::after {
  //   left: -443px;
  // }
  .lsm-icon10::after {
    left: -394px;
  }

  // .lsm-icon11::after {
  //   left: -480px;
  // }

  // ant-menu-submenu-open 子菜单展开class
  // ant-menu-submenu-selected 子菜单内有选中
  // ant-menu-submenu-active 子菜单hover

  .ant-menu-submenu-selected .lsm-icon::after,
  .ant-menu-submenu-active .lsm-icon::after,
  .ant-menu-item-active .lsm-icon::after,
  .ant-menu-item-selected .lsm-icon::after {
    top: -51px;
  }

  .ant-menu {
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }

  .ant-menu-sub {
    color: #999999;
  }

  // 选中效果
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #f7faff;
    font-weight: bold;
  }

  // 去掉右侧边框
  .ant-menu-inline {
    border: none;
  }

  .ant-menu-inline .ant-menu-item-selected::after {
    border-right: 0.016rem solid $mainColor;
    height: 0.125rem;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    right: auto;
  }

  .ant-menu-sub.ant-menu-inline {
    background-color: transparent;
  }
}

// 主要内容区域
#index-view .ant-layout-content {
  min-height: 120px;
  background: #f3f7ff;
  padding: 0.0521rem;
}
</style>
